export class ChangePasswordViewModel {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;    
    public serverNotifications: Map<string,string> = new Map<string, string>();
}